import React from 'react'
import AnimateImageThree from './AnimateImageThree'
import AnimateTitleThree from './AnimatedTitleThree'

const TailoringUnit = () => {
    return (
        <section className='section-tailoring-unit section-padding'>
            <div className='container'>
                <div className='row'>
                <div className='col-md-8 offset-md-2'>
                    <div className='section-img-heading'>
                        <div className='section-title our-team'>
                        <AnimateTitleThree/>
                     </div>
                    <div className='animated-image-wrapper'>
                        <AnimateImageThree/>
                    </div>
                    </div>
                   <div className='section-content-wrapper'>
                     <div className='section-paragraph'>
                        <p>We are a family-run enterprise driven by passion, purpose, and people. Every member of our team — from artisans and designers to merchandisers and support staff — shares a deep-rooted commitment to quality and creativity. Together, we bring to life bespoke embroideries and couture garments that embody excellence and emotion in equal measure.</p>
                        <p>At the heart of our company lies a spirit of collaboration and curiosity. Guided by our Chief Designer, trained at the prestigious <strong>École Lesage,</strong> and supported by a talented team, we continue to craft designs that shape the future of fashion. Each individual at <strong>India Embroidery Co</strong> is not just a contributor but an architect of tomorrow’s creative vision.</p>
                     </div>
                   </div>
                </div>
                </div>
            </div>
        </section>
    )
}

export default TailoringUnit